import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const PrivacyTh = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "th";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          TH
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/privacy">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/privacy">VI</Link>
            </li>
            <li className="selected">
              <em>TH</em>
            </li>
            <li>
              <Link to="/policy/id/privacy">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/privacy">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>นโยบายความเป็นส่วนตัวของ pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        วันที่มีผลบังคับใช้: [21 กันยายน 2026]
        <br />
        ปรับปรุงล่าสุด: [25 สิงหาคม 2026]
      </PolicyVersion>
      <PolicyText>
        Connecti Co., Ltd. (ต่อไปนี้เรียกว่า “Connecti”, “บริษัท” หรือ “เรา”)
        ให้ความสำคัญกับความเป็นส่วนตัวของผู้ใช้{" "}
        <strong>pregnancy&amp;baby</strong>{" "}
        และถือว่าการจัดการและคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้อย่างเหมาะสมและปลอดภัยเป็นความรับผิดชอบที่สำคัญของเรา
      </PolicyText>
      <PolicyText>
        นโยบายความเป็นส่วนตัวฉบับนี้อธิบายว่าเราเก็บรวบรวมข้อมูลส่วนบุคคลประเภทใด
        ใช้หรือประมวลผลข้อมูลดังกล่าวเพื่อวัตถุประสงค์ใด
        ข้อมูลอาจถูกเปิดเผยหรือโอนไปยังบุคคลอื่นในกรณีใด
        เราเก็บรักษาข้อมูลไว้นานเพียงใด
        และผู้ใช้มีสิทธิใดบ้างเกี่ยวกับข้อมูลส่วนบุคคลของตน
      </PolicyText>
      <PolicyText>
        นโยบายนี้ใช้กับแอปพลิเคชันมือถือ <strong>pregnancy&amp;baby</strong>{" "}
        เว็บไซต์ ตลอดจนผลิตภัณฑ์ ฟีเจอร์ และบริการที่เกี่ยวข้องทั้งหมด
        (รวมเรียกว่า “บริการ”)
      </PolicyText>
      <PolicyText>
        เราอาจแก้ไขนโยบายความเป็นส่วนตัวฉบับนี้เมื่อจำเป็น
        หากมีการเปลี่ยนแปลงที่สำคัญ เราจะแจ้งให้ผู้ใช้ทราบผ่านบริการ อีเมล
        หรือวิธีการอื่นที่เหมาะสมตามกฎหมายที่ใช้บังคับ และในกรณีที่กฎหมายกำหนด
        เราจะขอความยินยอมจากผู้ใช้สำหรับการเปลี่ยนแปลงดังกล่าว
      </PolicyText>

      <PolicySectionTitle>
        1. ข้อมูลส่วนบุคคลที่เราเก็บรวบรวม
      </PolicySectionTitle>
      <PolicyText>
        เราอาจเก็บรวบรวมข้อมูลที่ผู้ใช้ให้แก่เราโดยตรง
        ข้อมูลที่เก็บรวบรวมโดยอัตโนมัติระหว่างการใช้บริการ
        และข้อมูลบางประเภทที่ได้รับจากผู้ให้บริการยืนยันตัวตนภายนอก
      </PolicyText>

      <PolicyArticleTitle>1.1 ข้อมูลบัญชีและโปรไฟล์</PolicyArticleTitle>
      <PolicyText>
        เมื่อผู้ใช้สร้างหรือใช้งานบัญชี เราอาจเก็บรวบรวมข้อมูลดังต่อไปนี้
      </PolicyText>
      <PolicyHyphenList>
        <li>ที่อยู่อีเมล</li>
        <li>ปีเกิด</li>
        <li>ชื่อเล่น</li>
        <li>รูปโปรไฟล์</li>
        <li>ภูมิภาคที่พำนัก</li>
        <li>ภาษา</li>
        <li>เขตเวลา</li>
      </PolicyHyphenList>
      <PolicyText>
        ข้อมูลที่เก็บรวบรวมจริงอาจแตกต่างกันไปตามฟีเจอร์ที่ผู้ใช้เลือกใช้และวิธีการสมัครบัญชี
      </PolicyText>

      <PolicyArticleTitle>
        1.2 ข้อมูลจากการเข้าสู่ระบบผ่านบริการภายนอก
      </PolicyArticleTitle>
      <PolicyText>ผู้ใช้สามารถสร้างบัญชีหรือเข้าสู่ระบบโดยใช้</PolicyText>
      <PolicyHyphenList>
        <li>Google</li>
        <li>Apple</li>
      </PolicyHyphenList>
      <PolicyText>
        เมื่อใช้บริการเข้าสู่ระบบของบุคคลภายนอก
        เราอาจได้รับข้อมูลดังต่อไปนี้จากผู้ให้บริการดังกล่าว
      </PolicyText>
      <PolicyHyphenList>
        <li>รหัสประจำบัญชี (ID)</li>
        <li>ชื่อหรือชื่อที่แสดง</li>
      </PolicyHyphenList>
      <PolicyText>
        ข้อมูลที่เราได้รับจริงอาจแตกต่างกันไปตามผู้ให้บริการและการตั้งค่าของผู้ใช้ในบริการนั้น
      </PolicyText>
      <PolicyText>
        การประมวลผลข้อมูลโดยผู้ให้บริการเข้าสู่ระบบแต่ละรายจะอยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการนั้น
      </PolicyText>

      <PolicyArticleTitle>
        1.3 ข้อมูลเกี่ยวกับสุขภาพ การเตรียมตัวตั้งครรภ์ การตั้งครรภ์ และสุขภาวะ
      </PolicyArticleTitle>
      <PolicyText>
        ฟีเจอร์บางอย่างของบริการอนุญาตให้ผู้ใช้เลือกบันทึกข้อมูลเกี่ยวกับสุขภาพ
        การเตรียมตัวตั้งครรภ์ การตั้งครรภ์ และสุขภาวะของตน
      </PolicyText>
      <PolicyText>
        ข้อมูลที่เก็บรวบรวมอาจแตกต่างกันตามฟีเจอร์ที่ใช้
        และอาจรวมถึงข้อมูลดังต่อไปนี้
      </PolicyText>

      <PolicyList>
        <li>
          <strong>การเตรียมตัวตั้งครรภ์</strong>
          <PolicyHyphenList>
            <li>ระยะเวลาและรอบประจำเดือน</li>
            <li>วันที่มีประจำเดือนครั้งล่าสุด</li>
            <li>วันที่เริ่มและสิ้นสุดประจำเดือน</li>
            <li>วันตกไข่</li>
            <li>วันที่และเวลาที่ตรวจการตกไข่</li>
            <li>รูปภาพและผลตรวจการตกไข่</li>
            <li>วันที่และเวลาที่ตรวจการตั้งครรภ์</li>
            <li>รูปภาพและผลตรวจการตั้งครรภ์</li>
            <li>อุณหภูมิร่างกายพื้นฐาน</li>
            <li>อาการต่าง ๆ</li>
            <li>บันทึกอาการปวดและเลือดออก</li>
            <li>บันทึกการใช้ยา</li>
            <li>บันทึกการฉีดวัคซีน</li>
            <li>บันทึกการเข้ารับการตรวจหรือพบแพทย์</li>
            <li>บันทึกการมีเพศสัมพันธ์</li>
            <li>บันทึกและข้อมูลอื่น ๆ ที่ผู้ใช้เลือกกรอก</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>การรักษาภาวะมีบุตรยาก</strong>
          <PolicyHyphenList>
            <li>วิธีการรักษาภาวะมีบุตรยาก</li>
            <li>รอบและจำนวนครั้งของการรักษา</li>
            <li>วันที่เริ่มและสิ้นสุดการรักษา</li>
            <li>บันทึกการใช้ยาและการฉีดยา</li>
            <li>ตารางและรายละเอียดการรักษา</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>การตั้งครรภ์</strong>
          <PolicyHyphenList>
            <li>กำหนดคลอด</li>
            <li>ชื่อเล่นของทารกในครรภ์</li>
            <li>อายุครรภ์</li>
            <li>ข้อมูลบันทึกการตั้งครรภ์</li>
            <li>บันทึกการฝากครรภ์หรือการพบแพทย์</li>
            <li>บันทึกการฉีดวัคซีน</li>
            <li>บันทึกน้ำหนัก</li>
            <li>ภาพอัลตราซาวด์</li>
            <li>ค่าการวัดทารกในครรภ์ เช่น EFW, AC, FL, BPD, HC และ CRL</li>
            <li>ส่วนสูงและน้ำหนักก่อนตั้งครรภ์</li>
            <li>ประวัติการเปลี่ยนแปลงของน้ำหนัก</li>
            <li>ข้อมูลอื่น ๆ เกี่ยวกับการตั้งครรภ์ที่ผู้ใช้เลือกกรอก</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>การดูแลเด็กและการดูแลหลังคลอด</strong>
          <br />
          เราอาจเก็บรวบรวมข้อมูลเกี่ยวกับเด็กตามฟีเจอร์ที่ผู้ใช้เลือกใช้ ได้แก่
          <PolicyHyphenList>
            <li>ชื่อเด็ก</li>
            <li>เพศ</li>
            <li>วันเดือนปีเกิด</li>
            <li>น้ำหนักแรกเกิด</li>
            <li>ส่วนสูงแรกเกิด</li>
            <li>เส้นรอบศีรษะแรกเกิด</li>
            <li>กำหนดคลอด</li>
            <li>บันทึกการตรวจสุขภาพ</li>
            <li>บันทึกการฉีดวัคซีน</li>
            <li>ข้อมูลการเจริญเติบโต เช่น ส่วนสูง น้ำหนัก และเส้นรอบศีรษะ</li>
            <li>บันทึกและคะแนนการประเมินพัฒนาการ</li>
            <li>รูปภาพที่เกี่ยวข้องกับพัฒนาการ</li>
            <li>ข้อมูลเกี่ยวกับการคลอดก่อนกำหนด</li>
            <li>บันทึกอุณหภูมิร่างกาย</li>
            <li>บันทึกการใช้ยา</li>
            <li>ข้อมูลเกี่ยวกับการเจ็บป่วย</li>
          </PolicyHyphenList>
          สำหรับฟีเจอร์การจัดการน้ำหนักหลังคลอด
          เราอาจเก็บรวบรวมข้อมูลดังต่อไปนี้ด้วย
          <PolicyHyphenList>
            <li>ส่วนสูงและน้ำหนักก่อนตั้งครรภ์</li>
            <li>น้ำหนักก่อนคลอด</li>
            <li>บันทึกน้ำหนักหลังคลอด</li>
          </PolicyHyphenList>
          ข้อมูลบางส่วนข้างต้น โดยเฉพาะข้อมูลเกี่ยวกับสุขภาพ อาจถือเป็น{" "}
          <strong>ข้อมูลส่วนบุคคลที่มีความอ่อนไหว</strong> ตามกฎหมายที่ใช้บังคับ
          <br />
          ในกรณีที่กฎหมายกำหนด
          เราจะขอความยินยอมโดยชัดแจ้งหรือความยินยอมแยกต่างหากจากผู้ใช้ก่อนเก็บรวบรวมหรือประมวลผลข้อมูลดังกล่าว
        </li>
      </PolicyList>

      <PolicyArticleTitle>1.4 ข้อมูลจากฟีเจอร์ชุมชน</PolicyArticleTitle>
      <PolicyText>
        เมื่อผู้ใช้ใช้ฟีเจอร์ชุมชนของ <strong>pregnancy&amp;baby</strong>{" "}
        เราอาจประมวลผลข้อมูลดังต่อไปนี้
      </PolicyText>
      <PolicyHyphenList>
        <li>ชื่อเล่น</li>
        <li>รูปโปรไฟล์</li>
        <li>โพสต์</li>
        <li>ความคิดเห็น</li>
        <li>การโหวตและคำตอบในการโหวต</li>
        <li>รูปภาพและเนื้อหาอื่น ๆ ที่ผู้ใช้เลือกโพสต์</li>
      </PolicyHyphenList>
      <PolicyText>
        ข้อมูลที่โพสต์ในพื้นที่ชุมชนอาจปรากฏให้ผู้ใช้รายอื่นเห็น
        ผู้ใช้ควรใช้ความระมัดระวังในการเปิดเผยข้อมูลส่วนบุคคลในพื้นที่สาธารณะ
      </PolicyText>

      <PolicyArticleTitle>
        1.5 ข้อมูลที่เก็บรวบรวมโดยอัตโนมัติ
      </PolicyArticleTitle>
      <PolicyText>
        เมื่อผู้ใช้ใช้บริการ
        ข้อมูลทางเทคนิคและข้อมูลการใช้งานบางประเภทอาจถูกเก็บรวบรวมโดยอัตโนมัติ
        เช่น
      </PolicyText>
      <PolicyHyphenList>
        <li>ประเภทและรุ่นของอุปกรณ์</li>
        <li>ระบบปฏิบัติการและเวอร์ชัน</li>
        <li>เวอร์ชันของแอป</li>
        <li>ภาษา</li>
        <li>เขตเวลา</li>
        <li>ที่อยู่ IP</li>
        <li>ข้อมูลเกี่ยวกับการใช้งานและการดำเนินการภายในแอป</li>
        <li>ฟีเจอร์ที่เข้าถึงหรือใช้งาน</li>
        <li>ความถี่ในการใช้งาน</li>
        <li>ข้อมูลการโต้ตอบกับฟีเจอร์</li>
        <li>ข้อมูลข้อผิดพลาดและข้อมูลการวินิจฉัย</li>
        <li>
          โทเค็นการลงทะเบียน FCM
          หรือโทเค็นอื่นที่จำเป็นสำหรับการส่งการแจ้งเตือนแบบพุช
        </li>
      </PolicyHyphenList>
      <PolicyText>
        เว็บไซต์ของเราอาจใช้คุกกี้หรือเทคโนโลยีที่คล้ายคลึงกันตามความจำเป็น
      </PolicyText>

      <PolicyArticleTitle>1.6 ข้อมูลเพื่อการวิเคราะห์</PolicyArticleTitle>
      <PolicyText>
        เราใช้ <strong>Google Analytics for Firebase</strong>{" "}
        เพื่อทำความเข้าใจว่าผู้ใช้ใช้บริการอย่างไร
        และเพื่อปรับปรุงฟังก์ชันและประสบการณ์ของผู้ใช้
      </PolicyText>
      <PolicyText>ข้อมูลที่ใช้ในการวิเคราะห์อาจรวมถึง</PolicyText>
      <PolicyHyphenList>
        <li>ข้อมูลการใช้งานแอป</li>
        <li>ข้อมูลเซสชัน</li>
        <li>การใช้งานและการโต้ตอบกับฟีเจอร์</li>
        <li>ข้อมูลอุปกรณ์และระบบปฏิบัติการ</li>
        <li>ข้อมูลทางเทคนิคและข้อมูลการวินิจฉัยทั่วไป</li>
      </PolicyHyphenList>

      <PolicySectionTitle>
        2. วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล
      </PolicySectionTitle>
      <PolicyText>
        เราประมวลผลข้อมูลส่วนบุคคลเฉพาะในขอบเขตที่จำเป็นสำหรับวัตถุประสงค์ที่ชัดเจนและชอบด้วยกฎหมาย
        ซึ่งอาจรวมถึง
      </PolicyText>
      <PolicyHyphenList>
        <li>การสร้าง ยืนยันตัวตน และจัดการบัญชี</li>
        <li>การให้บริการและดำเนินงานบริการ</li>
        <li>
          การคาดการณ์ประจำเดือนครั้งถัดไป ช่วงที่มีโอกาสตั้งครรภ์สูง และวันตกไข่
        </li>
        <li>การบันทึกและวิเคราะห์ผลตรวจการตกไข่และผลตรวจการตั้งครรภ์</li>
        <li>การจัดการตารางและการแจ้งเตือนเกี่ยวกับการรักษาภาวะมีบุตรยาก</li>
        <li>การคำนวณอายุครรภ์และกำหนดคลอด</li>
        <li>การให้เนื้อหาและรายงานเกี่ยวกับการตั้งครรภ์</li>
        <li>การวิเคราะห์ค่าการเจริญเติบโตของทารกในครรภ์</li>
        <li>การให้บริการจัดการน้ำหนักระหว่างตั้งครรภ์และหลังคลอด</li>
        <li>การให้รายงานเกี่ยวกับการเจริญเติบโตและพัฒนาการของเด็ก</li>
        <li>
          การให้ฟีเจอร์จัดการสุขภาพ อุณหภูมิร่างกาย การใช้ยา การฉีดวัคซีน
          และการตรวจสุขภาพของเด็ก
        </li>
        <li>การให้เนื้อหาและบริการเฉพาะบุคคลตามข้อมูลที่ผู้ใช้ให้ไว้</li>
        <li>การส่งการแจ้งเตือนและการแจ้งเตือนแบบพุช</li>
        <li>การตอบข้อสอบถามและให้บริการลูกค้า</li>
        <li>การรักษาความปลอดภัยและความสมบูรณ์ของบริการ</li>
        <li>การตรวจจับและป้องกันการใช้งานหรือการเข้าถึงโดยไม่ได้รับอนุญาต</li>
        <li>การตรวจสอบประสิทธิภาพและข้อผิดพลาดของแอป</li>
        <li>การวิเคราะห์การใช้บริการ</li>
        <li>การปรับปรุงบริการที่มีอยู่และพัฒนาฟีเจอร์ใหม่</li>
        <li>
          การจัดทำสถิติและการวิจัยทางวิทยาศาสตร์โดยใช้ข้อมูลที่ทำให้ไม่สามารถระบุตัวบุคคลได้
        </li>
        <li>
          การปฏิบัติตามกฎหมายและตอบสนองต่อคำขอที่ชอบด้วยกฎหมายของหน่วยงานที่มีอำนาจ
        </li>
      </PolicyHyphenList>
      <PolicyText>เราไม่ขายหรือให้เช่าข้อมูลส่วนบุคคลของผู้ใช้</PolicyText>

      <PolicySectionTitle>
        3. ข้อมูลสุขภาพและข้อมูลส่วนบุคคลที่มีความอ่อนไหว
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>{" "}
        ให้บริการฟีเจอร์เกี่ยวกับการเตรียมตัวตั้งครรภ์ ประจำเดือน
        การรักษาภาวะมีบุตรยาก การตั้งครรภ์ สุขภาพของมารดา และการดูแลเด็ก
      </PolicyText>
      <PolicyText>
        ดังนั้น ข้อมูลบางประเภทที่ผู้ใช้ให้แก่เราอาจถือเป็น{" "}
        <strong>ข้อมูลส่วนบุคคลที่มีความอ่อนไหว</strong>{" "}
        ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลของประเทศไทยและกฎหมายอื่นที่ใช้บังคับ
      </PolicyText>
      <PolicyText>
        เราจะประมวลผลข้อมูลดังกล่าวเฉพาะเพื่อให้บริการฟีเจอร์ที่ผู้ใช้เลือก
        เพื่อวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้หรือที่แจ้งให้ผู้ใช้ทราบด้วยวิธีอื่น
        และภายในขอบเขตที่กฎหมายอนุญาต
      </PolicyText>
      <PolicyText>
        ในกรณีที่กฎหมายกำหนดให้ต้องได้รับความยินยอมสำหรับการเก็บรวบรวมหรือประมวลผลข้อมูลสุขภาพหรือข้อมูลส่วนบุคคลที่มีความอ่อนไหวอื่น
        เราจะขอความยินยอมโดยชัดแจ้งจากผู้ใช้
      </PolicyText>
      <PolicyText>
        เราไม่ขายข้อมูลสุขภาพหรือข้อมูลส่วนบุคคลที่มีความอ่อนไหวของผู้ใช้
      </PolicyText>

      <PolicySectionTitle>
        4. การวิเคราะห์อัตโนมัติและบริการเฉพาะบุคคล
      </PolicySectionTitle>
      <PolicyText>
        ฟีเจอร์บางอย่างของ <strong>pregnancy&amp;baby</strong>{" "}
        วิเคราะห์ข้อมูลที่ผู้ใช้ให้ไว้เพื่อแสดงผลลัพธ์ที่เหมาะสมกับผู้ใช้
      </PolicyText>
      <PolicyText>ตัวอย่างเช่น เราอาจวิเคราะห์ข้อมูลเพื่อ</PolicyText>
      <PolicyHyphenList>
        <li>คาดการณ์ประจำเดือนครั้งถัดไปและช่วงที่มีโอกาสตั้งครรภ์สูง</li>
        <li>คาดการณ์วันตกไข่</li>
        <li>วิเคราะห์ภาพผลตรวจการตกไข่หรือผลตรวจการตั้งครรภ์</li>
        <li>คำนวณความคืบหน้าของการตั้งครรภ์</li>
        <li>วิเคราะห์ค่าการเจริญเติบโตของทารกในครรภ์</li>
        <li>วิเคราะห์การเปลี่ยนแปลงน้ำหนักของมารดา</li>
        <li>วิเคราะห์การเจริญเติบโตและพัฒนาการของเด็ก</li>
      </PolicyHyphenList>
      <PolicyText>
        ผลการวิเคราะห์เหล่านี้มีไว้เพื่อให้ข้อมูลและสนับสนุนผู้ใช้ภายในบริการเท่านั้น
        และไม่ใช้แทนการวินิจฉัย การรักษา
        หรือคำแนะนำทางการแพทย์จากแพทย์หรือบุคลากรทางการแพทย์
      </PolicyText>

      <PolicySectionTitle>
        5. การแจ้งเตือนแบบพุชและการแจ้งเตือนอื่น ๆ
      </PolicySectionTitle>
      <PolicyText>
        ตามความยินยอมหรือการตั้งค่าของผู้ใช้
        เราอาจส่งการแจ้งเตือนแบบพุชเกี่ยวกับ
      </PolicyText>
      <PolicyHyphenList>
        <li>การแจ้งเตือนเกี่ยวกับการใช้บริการ</li>
        <li>การแจ้งเตือนเกี่ยวกับไดอารี่และบันทึกสุขภาพ</li>
        <li>ข้อมูลเกี่ยวกับการตั้งครรภ์หรือการดูแลเด็ก</li>
        <li>การอัปเดตบริการ</li>
        <li>
          กิจกรรม แคมเปญ
          หรือข้อมูลอื่นที่ผู้ใช้ได้ให้ความยินยอมแยกต่างหากในการรับ
        </li>
      </PolicyHyphenList>
      <PolicyText>
        เพื่อส่งการแจ้งเตือนแบบพุช เราจะประมวลผลโทเค็นการลงทะเบียน FCM
        หรือโทเค็นที่มีลักษณะเทียบเท่า
      </PolicyText>
      <PolicyText>
        ผู้ใช้สามารถเปลี่ยนการตั้งค่าการแจ้งเตือนได้ทุกเมื่อผ่านบริการหรือการตั้งค่าของอุปกรณ์
      </PolicyText>
      <PolicyText>
        แม้ผู้ใช้จะปิดการแจ้งเตือนที่เป็นทางเลือก
        เราอาจยังส่งประกาศสำคัญที่จำเป็นต่อการให้บริการภายในขอบเขตที่กฎหมายอนุญาต
      </PolicyText>

      <PolicySectionTitle>
        6. คุกกี้และเทคโนโลยีที่คล้ายคลึงกัน
      </PolicySectionTitle>
      <PolicyText>
        เว็บไซต์ของเราอาจใช้คุกกี้และเทคโนโลยีที่คล้ายคลึงกันตามความจำเป็นเพื่อดำเนินงานบริการ
        บันทึกการตั้งค่า ทำความเข้าใจการใช้งานบริการ
        และปรับปรุงประสบการณ์ของผู้ใช้
      </PolicyText>
      <PolicyText>
        ผู้ใช้สามารถจัดการคุกกี้ผ่านการตั้งค่าเบราว์เซอร์ อย่างไรก็ตาม
        หากปิดใช้งานคุกกี้บางประเภท
        ฟังก์ชันบางอย่างของเว็บไซต์อาจทำงานไม่ถูกต้อง
      </PolicyText>

      <PolicySectionTitle>7. ผู้ให้บริการภายนอก</PolicySectionTitle>
      <PolicyText>
        เราใช้ผู้ให้บริการภายนอกเพื่อดำเนินงาน ดูแล วิเคราะห์ และปรับปรุงบริการ
      </PolicyText>
      <PolicyTable>
        <caption className="hide">
          ประเภท, ผู้ให้บริการ, ข้อมูลที่เกี่ยวข้อง, วัตถุประสงค์
        </caption>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">ประเภท</th>
            <th scope="col">ผู้ให้บริการ</th>
            <th scope="col">ข้อมูลที่เกี่ยวข้อง</th>
            <th scope="col">วัตถุประสงค์</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>โครงสร้างพื้นฐานและการจัดเก็บ</td>
            <td>Amazon Web Services (AWS)</td>
            <td className="cell_left">ข้อมูลส่วนบุคคลที่ประมวลผลผ่านบริการ</td>
            <td className="cell_left">โฮสติ้งและการจัดเก็บข้อมูล</td>
          </tr>
          <tr>
            <td>การสื่อสาร</td>
            <td>NHN Cloud</td>
            <td className="cell_left">
              ข้อมูลติดต่อและข้อมูลที่เกี่ยวข้องกับการสื่อสาร
            </td>
            <td className="cell_left">การส่งข้อความและประกาศเกี่ยวกับบริการ</td>
          </tr>
          <tr>
            <td>การวิเคราะห์</td>
            <td>Google Analytics for Firebase</td>
            <td className="cell_left">ข้อมูลการใช้งานและข้อมูลวิเคราะห์แอป</td>
            <td className="cell_left">การวิเคราะห์และปรับปรุงบริการ</td>
          </tr>
          <tr>
            <td>การประมวลผลภาพ</td>
            <td>Google Cloud Vision</td>
            <td className="cell_left">
              ภาพที่อัปโหลดเพื่อใช้ฟีเจอร์วิเคราะห์ภาพ
            </td>
            <td className="cell_left">การวิเคราะห์ภาพและให้บริการฟีเจอร์</td>
          </tr>
          <tr>
            <td>การตรวจสอบแอปพลิเคชัน</td>
            <td>Sentry</td>
            <td className="cell_left">
              บันทึกแอป ข้อผิดพลาด และข้อมูลการวินิจฉัย
            </td>
            <td className="cell_left">
              การตรวจสอบประสิทธิภาพและติดตามข้อผิดพลาด
            </td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyText>
        ผู้ให้บริการภายนอกจะประมวลผลข้อมูลเฉพาะในขอบเขตที่จำเป็นเพื่อให้บริการแก่เรา
        และอยู่ภายใต้ข้อผูกพันตามสัญญาและกฎหมายที่ใช้บังคับ
      </PolicyText>
      <PolicyText>
        รายชื่อผู้ให้บริการอาจเปลี่ยนแปลงตามการปรับปรุงหรือเปลี่ยนแปลงบริการ
      </PolicyText>

      <PolicySectionTitle>
        8. กรณีที่เราเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคล
      </PolicySectionTitle>
      <PolicyText>เราไม่ขายหรือให้เช่าข้อมูลส่วนบุคคลของผู้ใช้</PolicyText>
      <PolicyText>
        เราอาจเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคลเฉพาะในขอบเขตที่จำเป็น เช่น
      </PolicyText>
      <PolicyHyphenList>
        <li>
          แก่ผู้ให้บริการภายนอกที่ประมวลผลข้อมูลเพื่อสนับสนุนการดำเนินงานของเรา
        </li>
        <li>เมื่อผู้ใช้ร้องขอหรือให้ความยินยอม</li>
        <li>
          เมื่อจำเป็นเพื่อปฏิบัติตามกฎหมาย คำสั่งศาล
          หรือคำขอที่ชอบด้วยกฎหมายจากหน่วยงานที่มีอำนาจ
        </li>
        <li>
          เมื่อมีความจำเป็นอย่างสมเหตุสมผลเพื่อคุ้มครองสิทธิ ความปลอดภัย
          หรือความมั่นคงของผู้ใช้ ผู้ใช้รายอื่น บริษัท หรือบริการ
        </li>
        <li>
          ในกรณีการควบรวมกิจการ การเข้าซื้อกิจการ การปรับโครงสร้าง การระดมทุน
          การโอนธุรกิจหรือทรัพย์สิน หรือธุรกรรมทางธุรกิจที่คล้ายกัน
          ภายในขอบเขตที่กฎหมายอนุญาต
        </li>
      </PolicyHyphenList>
      <PolicyText>
        ข้อมูลที่ได้รับการทำให้ไม่สามารถระบุตัวบุคคลได้อย่างถาวรและไม่สามารถย้อนกลับเพื่อระบุตัวบุคคลได้
        อาจถูกใช้หรือแบ่งปันตามกฎหมายที่ใช้บังคับ
      </PolicyText>

      <PolicySectionTitle>
        9. ข้อมูลที่ไม่สามารถระบุตัวบุคคลและการใช้เพื่อการวิจัย
      </PolicySectionTitle>
      <PolicyText>
        เราอาจทำให้ข้อมูลบางส่วนที่เกิดจากการใช้บริการไม่สามารถระบุตัวบุคคลได้
        เพื่อใช้สำหรับสถิติ การวิเคราะห์ การวิจัยทางวิทยาศาสตร์
        และการปรับปรุงบริการ
      </PolicyText>
      <PolicyText>
        การวิจัยดังกล่าวอาจเกี่ยวข้องกับสุขภาพของผู้หญิง การเตรียมตัวตั้งครรภ์
        การตั้งครรภ์ สุขภาพของมารดา ตลอดจนการเจริญเติบโตและพัฒนาการของเด็ก
      </PolicyText>
      <PolicyText>กระบวนการดังกล่าวมีวัตถุประสงค์เพื่อ</PolicyText>
      <PolicyHyphenList>
        <li>ทำให้ไม่สามารถระบุตัวผู้ใช้จากข้อมูลได้อย่างสมเหตุสมผล</li>
        <li>ลบข้อมูลระบุตัวตนที่สามารถเชื่อมโยงข้อมูลกับบัญชีผู้ใช้</li>
        <li>
          ป้องกันไม่ให้ข้อมูลที่ผ่านกระบวนการดังกล่าวเชื่อมโยงกลับไปยังบัญชีหรือข้อมูลส่วนบุคคลของผู้ใช้
        </li>
        <li>ทำให้เราไม่สามารถระบุตัวผู้ใช้กลับคืนจากข้อมูลดังกล่าวได้</li>
      </PolicyHyphenList>
      <PolicyText>
        ข้อมูลที่ผ่านกระบวนการจนไม่สามารถระบุตัวบุคคลได้อย่างถาวรและไม่สามารถย้อนกลับได้
        จะได้รับการจัดการตามกฎหมายที่ใช้บังคับ
      </PolicyText>
      <PolicyText>
        <strong>
          เราอาจเก็บรักษาข้อมูลดังกล่าวโดยไม่มีกำหนดระยะเวลาเพื่อวัตถุประสงค์ด้านการวิจัย
          สถิติ การวิเคราะห์ และการปรับปรุงบริการ
        </strong>
      </PolicyText>
      <PolicyText>
        ในกรณีที่ไม่สามารถระบุตัวบุคคลได้อย่างสมเหตุสมผล
        เราอาจใช้หรือแบ่งปันข้อมูลหรือผลการวิจัยที่ไม่สามารถระบุตัวบุคคลหรือข้อมูลแบบรวมกับสถาบันวิจัยหรือพันธมิตรอื่น
      </PolicyText>

      <PolicySectionTitle>
        10. ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคลและการลบบัญชี
      </PolicySectionTitle>
      <PolicyText>
        เราเก็บรักษาข้อมูลส่วนบุคคลที่สามารถระบุตัวผู้ใช้ได้เฉพาะระยะเวลาที่จำเป็นอย่างสมเหตุสมผลเพื่อให้บริการ
        บรรลุวัตถุประสงค์ที่ระบุในนโยบายนี้ หรือปฏิบัติตามหน้าที่ตามกฎหมาย
      </PolicyText>
      <PolicyList>
        <li>
          <strong>การลบบัญชี</strong>
          <br />
          ผู้ใช้สามารถลบบัญชีผ่านฟังก์ชันลบบัญชีหรือยกเลิกสมาชิกภายในบริการ
          หรือส่งคำขอถึงเรา
          <br />
          เมื่อลบบัญชี
          <PolicyHyphenList>
            <li>บัญชีของผู้ใช้จะถูกยกเลิก</li>
            <li>
              ข้อมูลส่วนบุคคลที่สามารถระบุตัวผู้ใช้ได้จะถูกลบหรือทำลายตามกฎหมายที่ใช้บังคับ
            </li>
            <li>
              หากผู้ใช้สร้างบัญชีใหม่ในภายหลัง
              ข้อมูลส่วนบุคคลจากบัญชีเดิมจะไม่ถูกนำกลับมาใช้หรือกู้คืน
            </li>
          </PolicyHyphenList>
          อย่างไรก็ตาม เราอาจเก็บรักษาข้อมูลบางส่วนตามระยะเวลาที่จำเป็น
          หากกฎหมายกำหนดหรืออนุญาต เช่น เพื่อปฏิบัติตามหน้าที่ตามกฎหมาย
          แก้ไขข้อพิพาท ป้องกันการฉ้อโกง หรือใช้สิทธิตามสัญญา
          <br />
          ตามที่ระบุไว้ในข้อ 9
          ข้อมูลบางส่วนที่เกี่ยวข้องกับการใช้บริการอาจถูกทำให้{" "}
          <strong>
            ไม่สามารถระบุตัวบุคคลได้อย่างถาวรและไม่สามารถย้อนกลับได้
          </strong>{" "}
          ก่อนหรือระหว่างกระบวนการลบบัญชี
          และอาจถูกเก็บรักษาโดยไม่มีกำหนดเพื่อการวิจัย สถิติ การวิเคราะห์
          และการปรับปรุงบริการ
          ข้อมูลดังกล่าวไม่สามารถเชื่อมโยงกลับไปยังผู้ใช้ได้
        </li>
        <li>
          <strong>การลบแอป</strong>
          <br />
          การถอนการติดตั้งแอป <strong>pregnancy&amp;baby</strong>{" "}
          ออกจากอุปกรณ์ไม่ได้เป็นการลบบัญชีหรือข้อมูลส่วนบุคคลโดยอัตโนมัติ
          <br />
          หากต้องการลบข้อมูลส่วนบุคคล
          ผู้ใช้ต้องลบบัญชีผ่านบริการหรือส่งคำขอลบข้อมูลถึงเรา
        </li>
      </PolicyList>

      <PolicySectionTitle>
        11. สิทธิของเจ้าของข้อมูลส่วนบุคคล
      </PolicySectionTitle>
      <PolicyText>
        ภายใต้กฎหมายที่ใช้บังคับ ผู้ใช้อาจมีสิทธิเกี่ยวกับข้อมูลส่วนบุคคลของตน
        รวมถึง
      </PolicyText>
      <PolicyHyphenList>
        <li>สิทธิในการเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคล</li>
        <li>สิทธิในการขอรับหรือโอนข้อมูลส่วนบุคคลในกรณีที่กฎหมายกำหนด</li>
        <li>สิทธิในการคัดค้านการประมวลผล</li>
        <li>สิทธิในการขอให้ลบหรือทำลายข้อมูลส่วนบุคคล</li>
        <li>สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคล</li>
        <li>
          สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์
          และไม่ก่อให้เกิดความเข้าใจผิด
        </li>
        <li>สิทธิในการถอนความยินยอมในกรณีที่การประมวลผลอาศัยความยินยอม</li>
        <li>สิทธิอื่นตามกฎหมายที่ใช้บังคับ</li>
      </PolicyHyphenList>
      <PolicyText>
        การถอนความยินยอมจะไม่กระทบต่อความชอบด้วยกฎหมายของการประมวลผลที่ได้ดำเนินการก่อนการถอนความยินยอม
      </PolicyText>
      <PolicyText>
        สิทธิบางประการอาจอยู่ภายใต้ข้อจำกัดหรือข้อยกเว้นตามกฎหมาย
      </PolicyText>
      <PolicyText>
        หากต้องการใช้สิทธิหรือส่งคำขอเกี่ยวกับข้อมูลส่วนบุคคล โปรดติดต่อ
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
      <PolicyText>
        เราอาจขอข้อมูลที่จำเป็นอย่างสมเหตุสมผลเพื่อยืนยันตัวตนของผู้ยื่นคำขอก่อนดำเนินการตามคำขอ
      </PolicyText>

      <PolicySectionTitle>
        12. มาตรการรักษาความมั่นคงปลอดภัยของข้อมูล
      </PolicySectionTitle>
      <PolicyText>
        เราใช้มาตรการทางเทคนิคและมาตรการเชิงองค์กรที่เหมาะสมเพื่อปกป้องข้อมูลส่วนบุคคลจากการเข้าถึงโดยไม่ได้รับอนุญาต
        การสูญหาย การโจรกรรม การใช้ในทางที่ผิด การเปิดเผยโดยไม่ได้รับอนุญาต
        การเปลี่ยนแปลง หรือการทำลาย
      </PolicyText>
      <PolicyText>มาตรการดังกล่าวอาจรวมถึง</PolicyText>
      <PolicyHyphenList>
        <li>การเข้ารหัสข้อมูลระหว่างการส่งและการจัดเก็บตามความเหมาะสม</li>
        <li>การควบคุมสิทธิการเข้าถึง</li>
        <li>การตรวจสอบระบบ</li>
        <li>การจัดการช่องโหว่ด้านความปลอดภัย</li>
        <li>ขั้นตอนการรักษาความปลอดภัยภายใน</li>
        <li>การจำกัดการเข้าถึงข้อมูลส่วนบุคคลตามความจำเป็นในการปฏิบัติงาน</li>
      </PolicyHyphenList>
      <PolicyText>
        เฉพาะบุคลากรที่จำเป็นต้องเข้าถึงข้อมูลเพื่อปฏิบัติหน้าที่เท่านั้นที่จะได้รับสิทธิที่เหมาะสม
      </PolicyText>
      <PolicyText>
        อย่างไรก็ตาม
        ไม่มีวิธีการส่งหรือจัดเก็บข้อมูลทางอิเล็กทรอนิกส์ใดที่สามารถรับประกันความปลอดภัยได้อย่างสมบูรณ์
      </PolicyText>
      <PolicyText>
        หากเกิดเหตุละเมิดข้อมูลส่วนบุคคล เราจะดำเนินมาตรการที่เหมาะสม
        และแจ้งผู้ใช้หรือหน่วยงานที่เกี่ยวข้องตามที่กฎหมายกำหนด
      </PolicyText>

      <PolicySectionTitle>
        13. สถานที่จัดเก็บและการโอนข้อมูลส่วนบุคคลไปต่างประเทศ
      </PolicySectionTitle>
      <PolicyText>
        Connecti Co., Ltd. ตั้งอยู่ใน <strong>สาธารณรัฐเกาหลี</strong>
      </PolicyText>
      <PolicyText>
        โครงสร้างพื้นฐานหลักของแอปและการจัดเก็บข้อมูลของบริการใช้{" "}
        <strong>
          Amazon Web Services (AWS) ภูมิภาคเอเชียแปซิฟิก (โซล) ประเทศเกาหลีใต้
        </strong>
      </PolicyText>
      <PolicyText>
        ดังนั้น
        ข้อมูลส่วนบุคคลของผู้ใช้ในประเทศไทยอาจถูกจัดเก็บและประมวลผลในประเทศเกาหลีใต้
      </PolicyText>
      <PolicyText>
        นอกจากนี้ เนื่องจาก <strong>pregnancy&amp;baby</strong>{" "}
        ใช้ผู้ให้บริการระดับโลก
        ข้อมูลส่วนบุคคลหรือข้อมูลทางเทคนิคบางประเภทอาจถูกประมวลผลหรือเข้าถึงโดยผู้ให้บริการที่ตั้งอยู่ในประเทศอื่นนอกเหนือจากประเทศที่ผู้ใช้อาศัยอยู่
      </PolicyText>
      <PolicyText>ผู้ให้บริการดังกล่าวอาจรวมถึง</PolicyText>
      <PolicyHyphenList>
        <li>Amazon Web Services</li>
        <li>Google</li>
        <li>NHN Cloud</li>
        <li>Sentry</li>
      </PolicyHyphenList>
      <PolicyText>
        เมื่อมีการส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ
        เราจะดำเนินการตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลของประเทศไทยและกฎหมายอื่นที่ใช้บังคับ
        รวมถึงจัดให้มีมาตรการคุ้มครองที่เหมาะสม
        หรือดำเนินการตามฐานทางกฎหมายหรือข้อยกเว้นที่กฎหมายอนุญาต แล้วแต่กรณี
      </PolicyText>

      <PolicySectionTitle>14. ข้อมูลส่วนบุคคลของผู้เยาว์</PolicySectionTitle>
      <PolicyText>
        บริการนี้มีไว้สำหรับบุคคลที่มีอายุถึงเกณฑ์ซึ่งสามารถ
        <strong>
          ให้ความยินยอมที่มีผลตามกฎหมายด้วยตนเองเกี่ยวกับการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของตน
        </strong>
        ตามกฎหมายที่ใช้บังคับ
      </PolicyText>
      <PolicyText>
        หากกฎหมายกำหนดให้ต้องได้รับความยินยอมจากบิดามารดา ผู้ปกครอง
        หรือผู้แทนโดยชอบธรรมในการใช้บริการหรือประมวลผลข้อมูลส่วนบุคคล
        บุคคลที่ยังไม่ได้รับความยินยอมที่จำเป็นดังกล่าวจะไม่สามารถสร้างหรือใช้บัญชี{" "}
        <strong>pregnancy&amp;baby</strong> ได้
      </PolicyText>
      <PolicyText>
        เราไม่มีเจตนาเก็บรวบรวมข้อมูลส่วนบุคคลจากบุคคลที่ยังไม่สามารถให้ความยินยอมที่มีผลตามกฎหมายด้วยตนเองและยังไม่ได้รับความยินยอมที่จำเป็นจากบิดามารดา
        ผู้ปกครอง หรือผู้แทนโดยชอบธรรม
      </PolicyText>
      <PolicyText>
        หากคุณเชื่อว่าข้อมูลส่วนบุคคลของผู้เยาว์ถูกส่งให้เราโดยไม่เป็นไปตามกฎหมาย
        โปรดติดต่อ{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>{" "}
        เราจะตรวจสอบและดำเนินมาตรการที่เหมาะสม รวมถึงการลบข้อมูลเมื่อจำเป็น
      </PolicyText>

      <PolicySectionTitle>
        15. ข้อมูลส่วนบุคคลของเด็กที่ผู้ใช้ลงทะเบียน
      </PolicySectionTitle>
      <PolicyText>
        ฟีเจอร์การดูแลเด็กบางรายการอนุญาตให้บิดามารดา ผู้ปกครอง ผู้แทนโดยชอบธรรม
        หรือผู้มีอำนาจตามกฎหมายบันทึกข้อมูลเกี่ยวกับเด็ก
      </PolicyText>
      <PolicyText>ข้อมูลดังกล่าวอาจรวมถึง</PolicyText>
      <PolicyHyphenList>
        <li>ชื่อ</li>
        <li>เพศ</li>
        <li>วันเดือนปีเกิด</li>
        <li>ข้อมูลการวัดร่างกายเมื่อแรกเกิด</li>
        <li>ข้อมูลการเจริญเติบโต</li>
        <li>ข้อมูลพัฒนาการ</li>
        <li>ข้อมูลการตรวจสุขภาพ</li>
        <li>ข้อมูลการฉีดวัคซีน</li>
        <li>อุณหภูมิร่างกาย</li>
        <li>ข้อมูลการใช้ยา</li>
        <li>ข้อมูลเกี่ยวกับการเจ็บป่วย</li>
        <li>รูปภาพที่เกี่ยวข้อง</li>
      </PolicyHyphenList>
      <PolicyText>
        เมื่อบันทึกข้อมูลส่วนบุคคลของเด็กในบริการ
        ผู้ใช้ยืนยันว่าตนมีอำนาจตามกฎหมายในการให้และจัดการข้อมูลดังกล่าวในฐานะบิดามารดา
        ผู้ปกครอง ผู้แทนโดยชอบธรรม หรือบุคคลอื่นที่มีอำนาจตามกฎหมาย
      </PolicyText>
      <PolicyText>
        เราจะประมวลผลข้อมูลดังกล่าวเฉพาะเพื่อวัตถุประสงค์ที่ระบุในนโยบายนี้และภายในขอบเขตที่กฎหมายอนุญาต
      </PolicyText>

      <PolicySectionTitle>
        16. บริการเข้าสู่ระบบและบริการของบุคคลภายนอก
      </PolicySectionTitle>
      <PolicyText>
        เมื่อผู้ใช้เข้าสู่ระบบ <strong>pregnancy&amp;baby</strong> ด้วย Google,
        Apple
        การใช้บริการดังกล่าวจะอยู่ภายใต้ข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัวของผู้ให้บริการแต่ละรายด้วย
      </PolicyText>
      <PolicyText>
        บริการของเราอาจมีลิงก์ไปยังเว็บไซต์ แอปพลิเคชัน
        หรือบริการที่ดำเนินการโดยบุคคลภายนอก
      </PolicyText>
      <PolicyText>
        เราไม่รับผิดชอบต่อการประมวลผลข้อมูลส่วนบุคคลโดยอิสระของบุคคลภายนอก
        ผู้ใช้ควรตรวจสอบนโยบายความเป็นส่วนตัวของบุคคลภายนอกก่อนให้ข้อมูลส่วนบุคคลแก่บุคคลดังกล่าว
      </PolicyText>

      <PolicySectionTitle>17. การไม่ขายข้อมูลส่วนบุคคล</PolicySectionTitle>
      <PolicyText>เราไม่ขายหรือให้เช่าข้อมูลส่วนบุคคลของผู้ใช้</PolicyText>
      <PolicyText>
        เราไม่ขายข้อมูลส่วนบุคคลที่เกี่ยวข้องกับสุขภาพ การเตรียมตัวตั้งครรภ์
        การตั้งครรภ์ หรือเด็ก
      </PolicyText>

      <PolicySectionTitle>
        18. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
      </PolicySectionTitle>
      <PolicyText>
        เราอาจแก้ไขนโยบายความเป็นส่วนตัวฉบับนี้เพื่อสะท้อนถึง
      </PolicyText>
      <PolicyHyphenList>
        <li>การเปลี่ยนแปลงของบริการ</li>
        <li>การเปลี่ยนแปลงวิธีการประมวลผลข้อมูลส่วนบุคคล</li>
        <li>การเปลี่ยนแปลงผู้ให้บริการ</li>
        <li>การเปลี่ยนแปลงกฎหมายหรือข้อบังคับที่ใช้บังคับ</li>
      </PolicyHyphenList>
      <PolicyText>
        หากการเปลี่ยนแปลงมีผลกระทบอย่างมีนัยสำคัญต่อสิทธิของผู้ใช้หรือวิธีการที่เราประมวลผลข้อมูลส่วนบุคคล
        เราจะแจ้งให้ผู้ใช้ทราบด้วยวิธีที่เหมาะสมก่อนการเปลี่ยนแปลงมีผล
        ตามที่กฎหมายกำหนด
      </PolicyText>
      <PolicyText>
        ในกรณีที่กฎหมายกำหนด เราจะขอความยินยอมจากผู้ใช้อีกครั้ง
      </PolicyText>
      <PolicyText>
        วันที่มีผลบังคับใช้และวันที่ปรับปรุงล่าสุดจะแสดงไว้ที่ส่วนต้นของนโยบายฉบับนี้
      </PolicyText>

      <PolicySectionTitle>
        19. ช่องทางติดต่อเกี่ยวกับข้อมูลส่วนบุคคล
      </PolicySectionTitle>
      <PolicyText>
        หากมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้
        วิธีที่เราประมวลผลข้อมูลส่วนบุคคล
        หรือหากต้องการใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคล โปรดติดต่อ
      </PolicyText>
      <PolicyText>
        <strong>Connecti Co., Ltd.</strong>
        <br />
        B2F, Unit 56
        <br />
        176 Yanghwa-ro, Mapo-gu
        <br />
        Seoul, Republic of Korea
        <br />
        <strong>อีเมล:</strong>{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>

      <PolicySectionTitle>
        20. ข้อกำหนดสำหรับผู้ใช้ในประเทศไทย
      </PolicySectionTitle>
      <PolicyText>
        สำหรับข้อมูลส่วนบุคคลของผู้ใช้ในประเทศไทย เราจะประมวลผลข้อมูลตาม{" "}
        <strong>
          พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (Personal Data
          Protection Act: PDPA)
        </strong>{" "}
        และกฎหมายหรือข้อกำหนดที่เกี่ยวข้อง
      </PolicyText>
      <PolicyText>
        ข้อมูลเกี่ยวกับสุขภาพอาจถือเป็น{" "}
        <strong>ข้อมูลส่วนบุคคลที่มีความอ่อนไหว</strong>{" "}
        ซึ่งอยู่ภายใต้ข้อกำหนดและการคุ้มครองเพิ่มเติมตามกฎหมายไทย
      </PolicyText>
      <PolicyText>
        ในกรณีที่การประมวลผลข้อมูลดังกล่าวอาศัยความยินยอม
        เราจะขอความยินยอมโดยชัดแจ้งตามที่กฎหมายกำหนด
      </PolicyText>
      <PolicyText>
        ผู้ใช้ในประเทศไทยอาจมีสิทธิตาม PDPA
        ซึ่งรวมถึงสิทธิในการเข้าถึงและขอสำเนาข้อมูล
        สิทธิในการขอรับหรือโอนข้อมูลในกรณีที่กฎหมายกำหนด สิทธิในการคัดค้าน
        สิทธิในการลบหรือทำลายข้อมูล สิทธิในการระงับการใช้ข้อมูล
        สิทธิในการขอแก้ไขข้อมูล และสิทธิในการถอนความยินยอม
      </PolicyText>
      <PolicyText>
        เนื่องจากโครงสร้างพื้นฐานหลักของ <strong>pregnancy&amp;baby</strong>{" "}
        ตั้งอยู่ในประเทศเกาหลีใต้
        และผู้ให้บริการบางรายอาจประมวลผลข้อมูลนอกประเทศไทย
        ข้อมูลส่วนบุคคลของผู้ใช้ในประเทศไทยอาจถูกโอนไปต่างประเทศ
      </PolicyText>
      <PolicyText>
        เราจะดำเนินการโอนข้อมูลส่วนบุคคลไปต่างประเทศตามข้อกำหนดของกฎหมายไทย
        รวมถึงการพิจารณามาตรฐานการคุ้มครองข้อมูลของประเทศปลายทาง
        การจัดให้มีมาตรการคุ้มครองที่เหมาะสม
        หรือการอาศัยฐานทางกฎหมายหรือข้อยกเว้นที่กฎหมายกำหนด แล้วแต่กรณี
      </PolicyText>
      <PolicyText>
        หากต้องการใช้สิทธิในฐานะเจ้าของข้อมูลส่วนบุคคลหรือสอบถามเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคล
        โปรดติดต่อ:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
    </PolicyContainer>
  );
};

export default PrivacyTh;
